import { Box } from "@mui/material";
import type { GridPaginationModel, GridRowParams } from "@mui/x-data-grid";

import { YouTubeChannel } from "../youtubechannel.types";
import { getYouTubeChannelColumns } from "./YoutubeChannelColumns";
import { DataGrid } from "../../../../components/common/Index";

interface Props {
  rows: YouTubeChannel[];
  loading?: boolean;
  rowCount?: number;
  paginationModel: GridPaginationModel;
  onPaginationModelChange: (model: GridPaginationModel) => void;
  onView: (channel: YouTubeChannel) => void;
  onReauthenticate: (channel: YouTubeChannel) => void;
  onRowClick?: (params: GridRowParams<YouTubeChannel>) => void;
}

export default function YouTubeChannelDataGrid({
  rows,
  loading = false,
  rowCount = 0,
  paginationModel,
  onPaginationModelChange,
  onReauthenticate,
  onRowClick,
}: Props) {
  const columns = getYouTubeChannelColumns({
    onReauthenticate,
  });

  return (
    <Box>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        rowCount={rowCount}
        paginationMode="client"
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        onRowClick={onRowClick}
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
      />
    </Box>
  );
}
